import RecordMetadata from "#core/components/RecordMetadata"
import { UseJobProfileDetailsContexts } from "#job-profile/contexts/JobProfileDetailsContexts"
import { CheckCircle } from "@mui/icons-material"
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive"
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"
import LocalAirportIcon from "@mui/icons-material/LocalAirport"
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount"
import WorkIcon from "@mui/icons-material/Work"
import {
	Box,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Stack,
	Typography,
} from "@mui/material"
import { Fragment } from "react"

export default function JobProfileDetailsGenerals() {
	const { jobProfile } = UseJobProfileDetailsContexts()
	if (!jobProfile) return null

	return (
		<Card elevation={2}>
			<CardHeader
				title={
					<Typography
						variant="h5"
						component="h3"
						gutterBottom
						fontWeight="600"
						color="text.primary"
						sx={{ textTransform: "uppercase" }}
					>
						Información General
					</Typography>
				}
			/>
			<CardContent>
				<Stack spacing={2} width={"100%"}>
					<Items
						{...{
							label: "OBJETIVO GENERAL DEL PUESTO | propósito",
							value: jobProfile.objetivo,
							Icon: CheckCircle,
						}}
					/>
					{jobProfile.contribuciones && (
						<Fragment>
							<Divider />
							<Items
								{...{
									label: "CONTRIBUCIONES DE VALOR | OBJETIVOS ESPECÍFICOS",
									value: jobProfile.contribuciones,
									Icon: CheckCircle,
								}}
							/>
						</Fragment>
					)}
					<Divider />
					{/* <Stack direction={"row"} spacing={2}> */}
					<Box
						display={"flex"}
						gap={2}
						// alignContent={"center"}
						flexWrap="wrap"
						flexDirection={{ xs: "column", sm: "row" }}
					>
						<ItemsWrapper
							{...{
								label: "JEFE INMEDIATO",
								value: jobProfile.reporta_a_name,
								Icon: SupervisorAccountIcon,
							}}
						/>
						<ItemsWrapper
							{...{
								label: "Departamento",
								value: jobProfile.departamento_name,
								Icon: WorkIcon,
							}}
						/>
						<ItemsWrapper
							{...{
								label: "Departamento reporta a",
								value: jobProfile.reporta_a_departamento_name,
								Icon: WorkIcon,
							}}
						/>
						<ItemsWrapper
							{...{
								label: "Años de experiencia",
								value: jobProfile.years_of_experience,
								Icon: WorkIcon,
							}}
						/>
						<ItemsWrapper
							{...{
								label: "Educación",
								value: jobProfile.education,
								Icon: WorkIcon,
							}}
						/>
						<ItemsWrapper
							{...{
								label: "PUEDE VIAJAR",
								value: jobProfile.viajar ? "Si" : "No",
								Icon: jobProfile.viajar ? LocalAirportIcon : AirplanemodeInactiveIcon,
							}}
						/>
					</Box>
				</Stack>
				{/* </Stack> */}
			</CardContent>
		</Card>
	)
}

const Items = ({ label, value, Icon }) => {
	if (!value) return null
	return (
		<Box>
			<Box>
				<Typography
					variant="h6"
					component="h3"
					gutterBottom
					fontWeight="600"
					color="text.primary"
					sx={{
						textTransform: "uppercase",
						display: "flex",
						alignItems: "center",
						gap: 1,
					}}
				>
					{label}
				</Typography>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
					<Icon fontSize="small" color="action" />
					<Typography variant="body2" color="text.secondary">
						{value}
					</Typography>
				</Box>
			</Box>
		</Box>
	)
}
const ItemsWrapper = ({ label, value, Icon }) => {
	if (!value) return null
	return (
		<Box
			flex="1 1 auto"
			minWidth="200px" // asegura que no se haga demasiado pequeño
			maxWidth="200px"
		>
			<Items {...{ label, value, Icon }} />
		</Box>
	)
}
